<template>
  <div style="position:relative">
    <div class="butt">
      <a-button @click="submit" type="primary" v-if="$auth('relevant.save')" >保存</a-button>
      <a-button @click="reset" style="margin:0 10px">重置</a-button>
    </div>
    <a-spin :spinning="loading">
      <a-tree
        ref="tree"
        :treeData="treeData"
        checkable
        :checkStrictly="true"
        :autoExpandParent="autoExpandParent"
        @check="onCheck"
        @expand="onExpand"
        v-model="checkedKeys"
        :expandedKeys="expandedKeys"
      >
        <template slot="custom" slot-scope="role">
          <a-tooltip placement="topLeft" :title="role.subcompanyname">
            <span class="title-name">{{ role.subcompanyname }}</span>
          </a-tooltip>
        </template>
      </a-tree>
    </a-spin>

  </div>
</template>

<script>
import { getCompanyTree } from '@/api/organizationalStructure'
import { getSapData, setSapData } from '@/api/relevant.js'
export default {
  async mounted () {
    await this.initTree()
    await this.getSelectData()
  },
  data () {
    return {
      treeData: [],
      checkedKeys: [],
      expandedKeys: [],
      loading: false,
      autoExpandParent: true
    }
  },
  computed: {
    sapSatus () {
      return this.$store.state.relevant.sapSatus
    }
  },
  watch: {
    sapSatus (code) {
      this.getSelectData()
    }
  },
  methods: {
    // 树结构
    async initTree () {
      this.loading = true
      const res = await getCompanyTree()
      if (res && res.status === 0) {
        const loop = data => {
          for (let i = 0; i < data.length; i++) {
            // do
            data[i].key = data[i].type === 1
              ? data[i].id + ''
              : 'dep' + data[i].id
            data[i].disableCheckbox = data[i].type === 1
            data[i].scopedSlots = {
              title: 'custom'
            }
            if (data[i].children) {
              loop(data[i].children)
            }
          }
        }
        loop(res.data)
        this.treeData = res.data
        console.log(this.treeData)
      }
      this.loading = false
    },
    // 对应spa部门权限数据
    async getSelectData () {
      this.loading = true
      const params = { ord43: this.sapSatus.code }
      const res = await getSapData(params)
      if (res && res.status === 0) {
        this.checkedKeys = [`dep${res.data.deptId}`]
        // this.checkedKeys = ['']
        this.expandedKeys = this.getExpandedKeys()
      } else {
        this.$message.error(res.info.message)
      }
      this.loading = false
    },
    // 保存配置
    async submit () {
      if (this.checkedKeys.length === 0) {
        this.$message.warning('请至少选中一个部门')
        return
      }
      this.loading = true
      const params = {
        ord43: this.sapSatus.code,
        deptId: this.checkedKeys[0].slice(3)
      }
      const res = await setSapData(params)
      if (res && res.status === 0) {
        this.$message.success(res.info.message)
      } else {
        this.$message.error(res.info.message)
      }
      this.loading = false
    },
    reset () {
      this.getSelectData()
    },
    // dfs 由选中数组得展开数组
    getExpandedKeys () {
      let arr = []
      const stack = []
      const loop = data => {
        for (let i = 0; i < data.length; i++) {
          // do
          if (this.checkedKeys.indexOf(data[i].key) !== -1) {
            arr = [...arr, ...stack]
          }
          stack.push(data[i].key)
          if (data[i].children) {
            loop(data[i].children)
          }
          stack.pop()
        }
      }
      loop(this.treeData)
      return Array.from(new Set(arr))
    },
    onCheck (checkedKeys, e) {
      console.log(e)
      const key = e.node.eventKey
      this.checkedKeys = [key]
    },
    onExpand (expandedKeys, option) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .ant-tree.ant-tree-icon-hide {
  overflow-y: visible !important;
}
.butt {
  display:flex;
  position: absolute;
  top: 4px;
  left: 480px;
  z-index: 100;
}
</style>
